import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { KineticHero } from "@/components/KineticHero";
import { BigWord } from "@/components/BigWord";
import { HowWeWork } from "@/components/HowWeWork";
import { Reveal, ScrollMaskedLine } from "@/components/Reveal";
import { usePageTitle } from "@/lib/usePageTitle";

export default function Home() {
  usePageTitle("Mentheris | Research, Technology & Practice", "Mentheris works across research, technology and practice to understand emerging change, develop new ways of thinking about it, and build from what we learn.");
  return (
    <main data-testid="home-page">
      <KineticHero />

      <HowWeWork />

      {/* Central intellectual statement */}
      <section className="mx-auto max-w-[1400px] px-6 md:px-12 py-16 md:py-24" data-testid="central-statement">
        <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight max-w-5xl">
          <ScrollMaskedLine>Technology changes what is possible.</ScrollMaskedLine>
          <ScrollMaskedLine delay={0.18}>
            <span className="italic text-ember">We investigate what it changes around it.</span>
          </ScrollMaskedLine>
        </h2>
      </section>

      <BigWord word="RESEARCH" />

      {/* Research Dialogues band */}
      <section data-testid="dialogue-section">
        <div>
          <div className="bg-forest text-bone p-10 md:p-14 flex flex-col">
            <p className="text-xs tracking-[0.25em] uppercase text-bone/50 mb-6">Research Dialogues</p>
            <h2 className="font-serif text-3xl md:text-4xl tracking-tight">
              <ScrollMaskedLine>Research develops through conversation.</ScrollMaskedLine>
            </h2>
            <Reveal delay={0.2}>
              <p className="mt-6 text-bone/70 leading-relaxed max-w-xl text-sm">
                Mentheris brings researchers, practitioners and organisations together to explore
                emerging questions before the answers are settled.
              </p>
              <div className="flex flex-wrap items-center gap-6 mt-8">
                <Link
                  to="/research-dialogues"
                  data-testid="dialogue-explore-cta"
                  className="group inline-flex items-center gap-2 text-sm tracking-wide link-editorial"
                >
                  Explore Research Dialogues
                  <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

    </main>
  );
}
